<div
  class="script-container"
  *ngIf="!showConfirmationPopup && !showPrecheckOperation && !showScriptSavingPopup"
>
  <mat-dialog-content class="content">
    <div mat-dialog-title class="title">
      <i class="material-icons mdi mdi-content-save-outline"></i>Save
    </div>

    <div class="content-input">
      <div class="label"><b>Let's give your script a name</b></div>
      <input
        type="text"
        class="script_name"
        matInput
        placeholder="Provide a name for script"
        [(ngModel)]="scriptName"
        maxlength="30"
      />
      <mat-error class="error" *ngIf="isNameAlreadyExist() && scriptName"
        >Name is already exist</mat-error
      >
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="action">
    <button
      mat-flat-button
      (click)="onSaveClicked()"
      *ngIf="!saveAsNewScript"
      [disabled]="disableSaveButton()"
    >
      Save...
    </button>
    <button
      mat-flat-button
      (click)="onSaveClicked()"
      *ngIf="saveAsNewScript"
      [disabled]="disableSaveButton()"
    >
      Save
    </button>
    <button mat-button (click)="closeDialog({ dialogClose: false })">Cancel</button>
  </mat-dialog-actions>
</div>

<div class="script-container" *ngIf="showPrecheckOperation">
  <mat-dialog-content class="content">
    <div mat-dialog-title class="title">
      <i class="material-icons mdi mdi-bug-check-outline"></i>Save & Precheck
    </div>
    <div class="loader-content" *ngIf="isLoading">
      <div class="spinner">
        <mat-spinner [diameter]="60"></mat-spinner>
      </div>
      <div class="loader-text">
        <div class="text-message">Saving script...</div>
      </div>
    </div>
    <div class="script-description" *ngIf="!isLoading">
      <div class="items"><b>Your script must be prechecked before a test can use it.</b></div>
      <div class="items">
        Precheck sends your script to an agent where it will be validated for errors.
      </div>
      <div class="items" *ngIf="preCheckPassed">
        <b>Note:</b>
        <span class="notes">
          A temporary version of your script will be created.<br />
          Once precheck succeeds, the temporary version will be removed and written back to your
          script.
        </span>
      </div>
      <div class="confirm-message">Would you like to precheck your script?</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="action">
    <div class="button">
      <button mat-flat-button [disabled]="isLoading" (click)="savePrecheckScript()">
        Yes, Precheck my script
      </button>
      <button mat-stroked-button [disabled]="isLoading" (click)="onSaveMyScriptClicked()">
        No, just save my script
      </button>
      <button mat-button (click)="closeDialog(false)">Cancel</button>
    </div>
    <div
      class="link"
      [ngClass]="{ disabled: isLoading }"
      *ngIf="data.editMode"
      (click)="openSaveScript()"
    >
      Save as new script...
    </div>
  </mat-dialog-actions>
</div>

<div class="script-container" *ngIf="showConfirmationPopup">
  <mat-dialog-content class="content">
    <div mat-dialog-title class="title">Want to save your changes?</div>
    <div>Your changes will be lost if you do not save them.</div>
  </mat-dialog-content>
  <mat-dialog-actions class="action">
    <button mat-flat-button (click)="openSaveScript()">Save...</button>
    <button mat-button mat-button (click)="closeDialog(true)">Don't save</button>
    <button mat-button (click)="closeDialog(false)">Cancel</button>
  </mat-dialog-actions>
</div>

<div class="script-container" *ngIf="showScriptSavingPopup">
  <mat-dialog-content class="content">
    <div mat-dialog-title class="title">
      <i class="material-icons mdi mdi-content-save-outline"></i>Save
    </div>
    <div class="loader-content">
      <div class="spinner" *ngIf="isLoading">
        <mat-spinner [diameter]="60"></mat-spinner>
      </div>
      <div class="success-icon" *ngIf="!isLoading && !scriptSaveFailed">
        <i class="mdi mdi-check-circle-outline"></i>
      </div>
      <div class="error-icon" *ngIf="!isLoading && scriptSaveFailed">
        <i class="mdi mdi-close-circle-outline"></i>
      </div>
      <div class="loader-text">
        <div class="text-message" *ngIf="scriptStatusMessage">{{ scriptStatusMessage }}</div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="action">
    <button mat-flat-button [disabled]="isLoading" (click)="closeDialog(true)">Done</button>
  </mat-dialog-actions>
</div>
